import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiDomainInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.apiDomain || req.url.startsWith('http')) {
      return next.handle(req);
    }

    const apiReq = req.clone({ url: `${environment.apiDomain}${req.url}` });
    if (req.url.startsWith('/api') && !req.headers.has('content-type')) {
      console.log('setting content-type');
      req.headers.append('content-type', 'application/json');
    }
    return next.handle(apiReq);
  }
}
